// extracted by mini-css-extract-plugin
module.exports = {"box":"index_box_1zzJO","content":"index_content_xI_7F"};